// extracted by mini-css-extract-plugin
export var bodySections = "_at-8";
export var gray = "_at-7";
export var green = "_at-4";
export var iconContainer = "_at-9";
export var iconWidgetContainer = "_at-1";
export var phoneIcon = "_at-2";
export var red = "_at-5";
export var statusDot = "_at-3";
export var widgetContainer = "_at-0";
export var yellow = "_at-6";